export default "__VITE_ASSET__BERze_pd__"